// 安全培训教育记录及签字表
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="安全培训教育记录及签字表"
    top="5%"
    width="50%"
    :center="true"
    :before-close="doClose"
  >
    <div class="archives_box">
      <div class="df" style="justify-content: flex-end; margin-bottom: 10px">
        <el-button
          class="bgc-bv"
          style="margin: 0 10px"
          size="mini"
          @click="handlUpdate()"
          >更新数据</el-button
        >
        <el-button
          class="bgc-bv"
          style="margin: 0 10px"
          size="mini"
          @click="doDownload()"
          >下载</el-button
        >
      </div>
      <div id="pdf-content4" style="height: 600px"></div>
    </div>
  </el-dialog>
</template>

<script>
import pdf from "pdfobject";
export default {
  name: "SafetyTrainingSignUp",
  props: [],
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    showPop(res) {
      this.playload = JSON.parse(res);
      this.queryData();
    },
    queryData() {
      let params = {
        enterpriseId: this.playload.enterpriseId,
        phaseId: this.playload.phaseId,
      };
      this.$post("/biz/dm/safetyTrainSign/download", params)
        .then((res) => {
          if (res.status == "0") {
            this.dialogVisible = true;
            this.preview(res);
          } else {
            this.dialogVisible = false;
          }
        })
        .catch(() => {
          this.dialogVisible = false;
        });
    },
    handlUpdate() {
      // /biz/dm/safetyTrainSign/update
      let params = {
        enterpriseId: this.playload.enterpriseId,
        phaseId: this.playload.phaseId,
      };
      this.$post("/biz/dm/safetyTrainSign/update", params).then((res) => {
        this.preview(res);
      });
    },
    preview(res) {
      this.$nextTick(() => {
        pdf.embed(res.data.url, "#pdf-content4", {
          pdfOpenParams: {
            scrollbars: "0",
            toolbar: "0",
            statusbar: "1",
          },
        });
      });
    },
    doDownload() {
      this.$post("/biz/dm/safetyTrainSign/download", {
        enterpriseId: this.playload.enterpriseId,
        phaseId: this.playload.phaseId,
      }).then((res) => {
        // ;
        if (res.status == "0") {
          let url = res.data.download_url || "";
          window.open(url);
        }
      });
    },
    doClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style>
</style>